import {Context} from '@gongxigames/framework/core/fragments/BuilderX/types';
import {Component, ComponentProps} from './Component';
import {BaseTexture, Sprite, Texture} from 'pixi.js';
import {canvasUtils} from '@gongxigames/framework/core/utils';

export type GraphicProps = ComponentProps & {
    radius?: number;
    color: string;
    width: number;
    height: number;
};

export class Graphic extends Component<GraphicProps, Sprite> {
    public readonly jsxType: string = 'graphic';

    static propsFromJson(props: any): GraphicProps {
        const propsNormalized = {
            ...super.propsFromJson(props),
            radius: props.radius,
            color: props.color,
            width: props.width,
            height: props.height
        };

        return propsNormalized;
    }

    public clone(): Graphic {
        return new Graphic(this.props);
    }

    public propsToJson(): any {
        const result = super.propsToJson();

        result.radius = this.props.radius;
        result.color = this.props.color;
        result.width = this.props.width;
        result.height = this.props.height;

        return result;
    }

    public getConstructor(): new () => any {
        return Sprite;
    }

    public updateProps(context: Context, container: Sprite, element: Sprite): void {
        const props = this.props;
        let cornerRadius = 0;
        let rectWidth = 1;
        let rectHeight = 1;

        if (props.radius) {
            cornerRadius = props.radius = props.radius / 2;
            rectWidth = props.width;
            rectHeight = props.height;
        }

        const canvas = canvasUtils.createCanvas(rectWidth, rectHeight);
        const ctx = canvas.getContext('2d')!;

        ctx.fillStyle = props.color;

        if (cornerRadius > 0) {
            canvasUtils.drawRoundRect(ctx, 0, 0, rectWidth, rectHeight, cornerRadius);
        } else {
            ctx.fillRect(0, 0, 1, 1);
        }

        container.texture = new Texture(BaseTexture.from((canvas)));

        super.updateProps(context, container, element);
    }
}
